module.exports = __webpack_public_path__ + "img/uprooted.64088656.png";